import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-list" }
const _hoisted_2 = { class: "step-list" }
const _hoisted_3 = { class: "mt-10" }
const _hoisted_4 = { class: "step-list" }

import InfoBox from '@shell/components/InfoBox';
import CopyToClipboard from '@shell/components/CopyToClipboard';

type TArgs = {
  baseUrl: string;
  serverUrl: string;
  provider: string;
  username: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'github-app-steps',
  props: {
    name: {},
    tArgs: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _directive_clean_html = _resolveDirective("clean-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(InfoBox), {
      step: 1,
      class: "step-box"
    }, {
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_1, [
          _withDirectives(_createElementVNode("li", null, null, 512), [
            [_directive_clean_html, _ctx.t(`authConfig.${__props.name}.form.prefix.1`, __props.tArgs, true)]
          ]),
          _cache[0] || (_cache[0] = _createTextVNode()),
          _withDirectives(_createElementVNode("li", null, null, 512), [
            [_directive_clean_html, _ctx.t(`authConfig.${__props.name}.form.prefix.2`, __props.tArgs, true)]
          ]),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _withDirectives(_createElementVNode("li", null, null, 512), [
            [_directive_clean_html, _ctx.t(`authConfig.${__props.name}.form.prefix.3`, __props.tArgs, true)]
          ]),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _withDirectives(_createElementVNode("li", null, null, 512), [
            [_directive_clean_html, _ctx.t(`authConfig.${__props.name}.form.prefix.4`, __props.tArgs, true)]
          ])
        ])
      ]),
      _: 1
    }),
    _cache[11] || (_cache[11] = _createTextVNode()),
    _createVNode(_unref(InfoBox), {
      step: 2,
      class: "step-box"
    }, {
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", null, [
            _createTextVNode(_toDisplayString(_ctx.t(`authConfig.${__props.name}.form.instruction`, __props.tArgs, true)) + " ", 1),
            _createElementVNode("ul", _hoisted_3, [
              _createElementVNode("li", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.t(`authConfig.${__props.name}.form.app.label`)), 1),
                _cache[3] || (_cache[3] = _createTextVNode(":\n            ", -1)),
                _withDirectives(_createElementVNode("span", null, null, 512), [
                  [_directive_clean_html, _ctx.t(`authConfig.${__props.name}.form.app.value`, __props.tArgs, true)]
                ])
              ]),
              _cache[5] || (_cache[5] = _createTextVNode()),
              _createElementVNode("li", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.t(`authConfig.${__props.name}.form.homepage.label`)), 1),
                _createTextVNode(": " + _toDisplayString(__props.tArgs.serverUrl) + " ", 1),
                _createVNode(_unref(CopyToClipboard), {
                  "label-as": "tooltip",
                  text: __props.tArgs.serverUrl,
                  "aria-label": _ctx.t('generic.copyValueToClipboard', { value: __props.tArgs.serverUrl }),
                  class: "icon-btn",
                  "action-color": "bg-transparent"
                }, null, 8, ["text", "aria-label"])
              ]),
              _cache[6] || (_cache[6] = _createTextVNode()),
              _createElementVNode("li", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.t(`authConfig.${__props.name}.form.description.label`)), 1),
                _cache[4] || (_cache[4] = _createTextVNode(":\n            ", -1)),
                _withDirectives(_createElementVNode("span", null, null, 512), [
                  [_directive_clean_html, _ctx.t(`authConfig.${__props.name}.form.description.value`, __props.tArgs, true)]
                ])
              ]),
              _cache[7] || (_cache[7] = _createTextVNode()),
              _createElementVNode("li", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.t(`authConfig.${__props.name}.form.callback.label`)), 1),
                _createTextVNode(":\n            " + _toDisplayString(_ctx.t(`authConfig.${__props.name}.form.callback.value`, __props.tArgs, true)) + " ", 1),
                _createVNode(_unref(CopyToClipboard), {
                  text: _ctx.t(`authConfig.${__props.name}.form.callback.value`, __props.tArgs, true),
                  "label-as": "tooltip",
                  "aria-label": _ctx.t('generic.copyValueToClipboard', { value: _ctx.t(`authConfig.${__props.name}.form.callback.value`, __props.tArgs, true) }),
                  class: "icon-btn",
                  "action-color": "bg-transparent"
                }, null, 8, ["text", "aria-label"])
              ])
            ])
          ]),
          _cache[8] || (_cache[8] = _createTextVNode()),
          _createElementVNode("li", null, _toDisplayString(_ctx.t(`authConfig.${__props.name}.form.create`, __props.tArgs, true)), 1)
        ])
      ]),
      _: 1
    }),
    _cache[12] || (_cache[12] = _createTextVNode()),
    _createVNode(_unref(InfoBox), {
      step: 3,
      class: "mb-20"
    }, {
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_4, [
          _withDirectives(_createElementVNode("li", null, null, 512), [
            [_directive_clean_html, _ctx.t(`authConfig.${__props.name}.form.suffix.1`, __props.tArgs, true)]
          ]),
          _cache[9] || (_cache[9] = _createTextVNode()),
          _withDirectives(_createElementVNode("li", null, null, 512), [
            [_directive_clean_html, _ctx.t(`authConfig.${__props.name}.form.suffix.2`, __props.tArgs, true)]
          ]),
          _cache[10] || (_cache[10] = _createTextVNode()),
          _withDirectives(_createElementVNode("li", null, null, 512), [
            [_directive_clean_html, _ctx.t(`authConfig.${__props.name}.form.suffix.3`, __props.tArgs, true)]
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})